import { cx } from '@milanote/roma/utils';

const SEARCH_HIGHLIGHT_CLASS = 'search-highlight';

/**
 * Gets shared visual classes for generic element chip selection and highlighting.
 */
export const getChipClassNames = (isSelected: boolean, isSearchHighlighted: boolean) =>
    cx(
        'inline-flex w-auto max-w-full transition-none select-none',
        isSelected && 'ring-2 ring-primary_focused',
        isSearchHighlighted && `${SEARCH_HIGHLIGHT_CLASS} ring-2 ring-search`,
    );
